// FilterRail — the two pieces every filtered log is built from.
//
// A labelled group of chips, and a chip. Nothing more. They were written
// inline in TradesLog.tsx; the money-movement ledger needs the identical
// affordance, and a second copy is how two logs on the same console start
// filtering with two different chips. Extracted verbatim — the classes below
// are byte-for-byte the ones the trades log has been rendering, so that screen
// does not shift by a pixel.
//
// Desktop (lg+) follows the console token contract in styles.css: pill chips
// with a gold selected wash. Below lg they stay the square Mini App chips.

import type { ReactNode } from 'react';

export function FilterGroup({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <p className="text-label uppercase tracking-wider text-tg-hint mb-1.5 lg:tracking-[0.08em] lg:font-medium lg:mb-2">{label}</p>
      <div className="flex flex-wrap gap-1.5 lg:gap-1">{children}</div>
    </div>
  );
}

export function Chip({ active, onClick, title, children }: {
  active: boolean;
  onClick: () => void;
  title?: string;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      // The one chip (styles.css, emphasis rule): the active one is lit at
      // every width — accent text and border — never gold-filled.
      className={`chip ${active ? 'chip-on' : ''}`}
    >
      {children}
    </button>
  );
}
